"use strict";
/**
 * CSP Nonce Initialization for Webpack
 * =====================================
 * This file bridges the server-injected CSP nonce with webpack's runtime.
 *
 * BACKGROUND:
 * To comply with Content Security Policy (CSP), every inline script and style
 * injected by webpack must carry a valid nonce attribute. The nonce is generated
 * server-side (NGINX) on each request, injected into the HTML, and made available
 * on `window.__webpack_nonce__` via a bootstrap script in index.html.
 *
 * WHY THIS FILE EXISTS:
 * Webpack looks for `__webpack_nonce__` as a bare global variable at runtime —
 * it does NOT read from `window.__webpack_nonce__` automatically. This file
 * explicitly bridges the two.
 *
 * WHAT EACH LINE DOES:
 * - `__webpack_nonce__`      — applies the nonce to the initial bundle injection
 * - `__webpack_require__.nc` — applies the nonce to lazy-loaded chunks (code splitting
 *                              / dynamic imports). Without this, async chunks would be
 *                              injected without a nonce and blocked by CSP.
 *
 * LOAD ORDER:
 * This file MUST be the first entry point in the webpack config, before any
 * application code. If it runs too late, webpack will have already injected
 * assets without the nonce.
 *
 * DO NOT:
 * - Remove or rename this file
 * - Rename `__webpack_nonce__` or `__webpack_require__.nc`
 * - Move this file later in the webpack entry order
 *
 * @see https://webpack.js.org/guides/csp/
 * @see https://github.com/styled-components/styled-components/issues/887#issuecomment-789051197
 */
/* eslint-disable no-underscore-dangle */
/* eslint-disable camelcase */
// @ts-expect-error ...
__webpack_nonce__ = window.__webpack_nonce__;
/* eslint-disable no-underscore-dangle */
/* eslint-disable camelcase */
// @ts-expect-error ...
__webpack_require__.nc = window.__webpack_nonce__;
